import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	// Bump this to force re-render after state updates
	rev: 0,
	activeTipId: null,
	seenTips: [], // Array of tip IDs that have been seen (from API)
	loading: false,
	loaded: false, // Track if we've successfully loaded seen tips from API
	error: null,
};

const whatsnewSlice = createSlice({
	name: "whatsnew",
	initialState,
	reducers: {
		requestShow(state, action) {
			const tipId = action.payload;
			if (!state.activeTipId) {
				state.activeTipId = tipId;
			}
			state.rev++;
		},
		clearActive(state, action) {
			// clear only if matches (avoid clearing another component's claim)
			const tipId = action.payload;
			if (!tipId || state.activeTipId === tipId) {
				state.activeTipId = null;
			}
			state.rev++;
		},
		setSeenTips(state, action) {
			// Set the list of seen tips from API
			state.seenTips = action.payload || [];
			state.loaded = true; // Mark as loaded after successful fetch
			state.rev++;
		},
		markTipSeen(state, action) {
			// Add tip to seen list (called after successful API call)
			const tipId = action.payload;
			if (!state.seenTips.includes(tipId)) {
				state.seenTips.push(tipId);
			}
			state.rev++;
		},
		setLoading(state, action) {
			state.loading = action.payload;
		},
		setError(state, action) {
			state.error = action.payload;
		},
		resetTipForDev(state, action) {
			// dev helper: remove a tip from seen list
			const tipId = action.payload;
			state.seenTips = state.seenTips.filter(id => id !== tipId);
			state.rev++;
		},
	},
});

export const whatsnewActions = whatsnewSlice.actions;

// Selectors
export const selectActiveTipId = (state) => state.whatsnew.activeTipId;
export const selectIsTipEligible = (state, tipId) => {
	// Eligible if this tip is not in the seen tips list
	return !state.whatsnew.seenTips.includes(tipId);
};
export const selectSeenTips = (state) => state.whatsnew.seenTips;
export const selectTipsLoading = (state) => state.whatsnew.loading;
export const selectTipsLoaded = (state) => state.whatsnew.loaded;
export const selectTipsError = (state) => state.whatsnew.error;

export default whatsnewSlice;


